export const getUnitById = (units, id) => {
  return units.find((unit) => unit.id === id);
}